export default "__VITE_ASSET__DLtvGCKk__"